import { render, staticRenderFns } from "./HotTools.vue?vue&type=template&id=79a89cf4&scoped=true"
import script from "./HotTools.vue?vue&type=script&lang=js"
export * from "./HotTools.vue?vue&type=script&lang=js"
import style0 from "./HotTools.vue?vue&type=style&index=0&id=79a89cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a89cf4",
  null
  
)

export default component.exports